<template>
  <div class="document">
    <div class="header">
      <es-header>
        <!-- TODO: Add refresh icon -->
        <template #header>
          <div class="header-title">
            Match Results
          </div>
        </template>
      </es-header>
    </div>
    <div>
      <es-loader
        v-if="loading"
        style="margin: 3rem"
      />
      <es-exception
        v-else-if="loadingError"
        exceptionMessage="There was an issue. Please try again or contact your administrator."
        style="padding: 3rem; margin: 0"
      />
      <es-exception
        v-else-if="!batches.length && !transactions.length"
        exceptionMessage="Records must be submitted to view results."
        style="padding: 3rem; margin: 0"
      />
      <div
        v-else
        style="padding: .5rem 1.25rem .5rem 2rem"
      >
        <dm-batches
          v-if="batches.length"
          :batchList="batches"
        />
        <dm-transactions
          v-else-if="transactions.length"
          :transactionList="transactions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DmBatches from '@/components/DmBatches.vue';
import DmTransactions from '@/components/DmTransactions.vue';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';

export default {
  components: {
    DmBatches,
    DmTransactions,
    EsException,
    EsHeader,
    EsLoader,
    // PidBatchesTable,
  },
  props: {
    batches: {
      type: Array,
    },
    transactions: {
      type: Array,
    },
  },
  data() {
    return {
      loading: null,
      loadingError: null,
    };
  },
  mounted() {
    this.$root.$on('dmMatchOptionsLoading', this.setLoading);
    this.$root.$on('dmMatchOptionsLoadingError', this.setLoadingError);
  },
  destroyed() {
    this.$root.$off('dmMatchOptionsLoading');
    this.$root.$off('dmMatchOptionsLoadingError');
  },
  methods: {
    setLoading(val) {
      this.loading = val;
    },
    setLoadingError(val) {
      this.loadingError = val;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
